import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeatIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M584 313Q776 313 876 379.5 976 446 976 591 976 735 876 801.5 776 868 584 868L364 868 364 796 584 796Q745 796 824 750 903 704 903 591 903 478 824 431.5 745 385 584 385L126 385 300 541 256 586 0 349 256 112 300 157 126 313 584 313Z" })
});
export default SvgRepeatIcon;
